import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const AccountingInformationContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const SubDetailContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '1rem',

  '.subTitle': {
    borderBottom: `solid ${v.borderGray} 1px`,
    fontSize: '1.5rem',
    fontWeight: 'bold',
    paddingBottom: '0.25rem',
    marginBottom: '1rem',
  },

  '.ReactTable': {
    width: '-webkit-fill-available',
    height: 'fit-content',
    marginTop: '1rem',
    borderRadius: '5px',
  },

  '.ui.table td': {
    padding: '5px',
    borderRight: '1px solid rgba(34,36,38,.1)',
  },

  '.ui.table td:last-child': {
    borderRight: 'none',
  },

  '.ui.table thead th': {
    padding: '8px',
    borderRight: '1px solid rgba(34,36,38,.1)',
  },

  '.ui.table thead th:last-child': {
    borderRight: 'none',
  },
})